
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"145","height":"145","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M142.189 29.14H132.633v-3.26a2.81 2.81 0 00-2.023-2.81 79.176 79.176 0 00-20.265-2.586c-11.242 0-26.56 2.53-37.887 14.053C61.215 22.9 45.785 20.484 34.57 20.484a79.17 79.17 0 00-20.265 2.586 2.81 2.81 0 00-2.024 2.81v3.232H2.811A2.81 2.81 0 000 31.923v89.771a2.81 2.81 0 002.81 2.811 2.807 2.807 0 001.378-.365c.28-.141 28.387-15.515 67.623-5.622h.675c.224.027.45.027.674 0 39.349-9.977 67.455 5.369 67.624 5.622a2.812 2.812 0 004.216-2.418v-89.77a2.81 2.81 0 00-2.811-2.812zM5.621 117.225V34.762h6.718v70.49a2.81 2.81 0 003.232 2.811 122.858 122.858 0 0117.566-1.405 72.899 72.899 0 0124.003 3.625 103.337 103.337 0 00-51.519 6.942zm27.516-16.161c-5.112.012-10.218.34-15.29.984V28.101a77.518 77.518 0 0116.667-1.855c10.512 0 25.015 2.417 35.077 13.772l.084 70.012c-5.846-3.822-17.257-8.966-36.538-8.966zm42.16-61.046c10.062-11.243 24.564-13.772 35.076-13.772A77.864 77.864 0 01127.04 28.1v73.947a123.7 123.7 0 00-15.205-1.012c-19.169 0-30.608 5.144-36.538 8.966V40.018zm64.054 77.207a103.348 103.348 0 00-51.632-6.942 73.088 73.088 0 0124.116-3.625c5.918.033 11.826.493 17.678 1.377a2.811 2.811 0 003.233-2.811V34.762h6.717l-.112 82.463z","fill":"#4B62C1"}})])
          )
        }
      }
    